// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px;
  margin: 0;
  border-radius: 16px;
  background: var(--main-background);
  color: #fff;
}
.container .cross-icon {
  z-index: 99;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: transparent;
  width: 20px;
  height: 20px;
  padding: 0px;
}
.container .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.title {
  font-family: AppFontMedium, sans-serif;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #fff;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.info {
  font-family: AppFontLight;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
}

.button {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 25px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: var(--accent-color);
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #fff;
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  background: #a9715c;
}
.button_close {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border-radius: 26px;
  color: #fff;
}
.button_close:hover {
  background: rgba(255, 255, 255, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,WAAA;AACF;AAAE;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAGH;;AAEA;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;AAAF;;AAIA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,+BAAA;EACA,gCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAME;EACE,uBAAA;EACA,0CAAA;EACA,yBAAA;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,WAAA;AANJ;AAQI;EACE,qCAAA;AANN","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 35px;\n  margin: 0;\n  border-radius: 16px;\n  background: var(--main-background);\n  color: #fff;\n  .cross-icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: transparent;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tpadding: 0px;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n}\n\n.title {\n  font-family: AppFontMedium, sans-serif;\n  font-size: 20px;\n  line-height: 23px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: #fff;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.info {\n  font-family: AppFontLight;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.8);\n\n  text-transform: uppercase;\n\n}\n\n.button {\n  height: 40px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-top: 25px;\n  cursor: pointer;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main {\n    background: var(--accent-color);\n    font-family: AppFont, sans-serif;\n\n    font-size: 15px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: #fff;\n    border-radius: 26px;\n    text-transform: uppercase;\n    &:hover {\n      background: #a9715c;\n    }\n  }\n\n  &_close {\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    text-transform: uppercase;\n\n    font-family: AppFont, sans-serif;\n    font-size: 15px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n\n    border-radius: 26px;\n    color: #fff;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
